import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

export default function SubtaskPriorityPill({ priority }) {
  const className = useMemo(() => {
    switch (priority) {
      case 'Lowest':
        return 'subtask-priority-pill-lowest';
      case 'Low':
        return 'subtask-priority-pill-low';
      case 'Medium':
        return 'subtask-priority-pill-medium';
      case 'High':
        return 'subtask-priority-pill-high';
      case 'Highest':
        return 'subtask-priority-pill-highest';
      default:
        return '';
    }
  }, [priority]);

  return (
    <div className={className}>
      <svg className="subtask-priority-pill-icon" width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="3" cy="3" r="3" />
      </svg>
      {priority}
    </div>
  );
}

SubtaskPriorityPill.propTypes = {
  priority: PropTypes.string,
};

SubtaskPriorityPill.defaultProps = {
  priority: '',
};
